export default "__VITE_ASSET__BFcCqbiz__"